<template>
  <model-select
    v-model="currentBox"
    class="box-search"
    :options="options"
    :placeholder="$t('header.search.placeholder')"
  ></model-select>
</template>

<script>
import boxesQuery from '@/api/boxinfo/boxList.gql';

export default {
  name: 'BoxSearch',
  data() {
    return {
      currentBox: {
        value: '',
        text: '',
      },
    };
  },
  computed: {
    options() {
      let res = [];
      let boxes = this.boxes || [];

      boxes.forEach((el) =>
        res.push({
          value: el.deviceId,
          text: el.digitalThing.name,
        }),
      );

      return res;
    },
  },
  watch: {
    currentBox: function (val) {
      if (val && val.value) {
        this.$router.push({
          name: 'Boxinfo',
          params: {
            deviceId: val.value,
          },
        });
        this.currentBox = {};
      }
    },
  },
  apollo: {
    boxes: {
      query() {
        return boxesQuery;
      },
      deep: true,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.boxes && queryData.boxes.length) {
          return queryData.boxes;
        } else {
          return null;
        }
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.box-search.ui.search.selection.dropdown {
  background-color: #191c24;
  border: none;

  &::v-deep .dropdown.icon {
    display: block;
    padding-top: 7px;
    right: unset;
    &::before {
      content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23979BA7' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-search'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'%3E%3C/line%3E%3C/svg%3E");
    }
  }

  &::v-deep .search {
    padding-left: 53px;
    color: #ffffff;
  }

  &::v-deep .text.default {
    padding-left: 40px !important;
    color: #979ba7;
  }

  &::v-deep .menu.visible {
    background-color: #191c24;
    top: 50px;
    box-shadow: -2px -2px 4px #212530, 2px 2px 4px #14171d;
    border: none;
    & .item {
      color: #ffffff;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      height: 44px;
      background-color: #191c24;
      display: flex;
      align-items: center;

      &.selected {
        background-color: #1f222a;
      }
    }
  }
}
</style>
